import { render, staticRenderFns } from "./role-bind-menu.vue?vue&type=template&id=d7c106b2&scoped=true&"
import script from "./role-bind-menu.vue?vue&type=script&lang=js&"
export * from "./role-bind-menu.vue?vue&type=script&lang=js&"
import style0 from "./role-bind-menu.vue?vue&type=style&index=0&id=d7c106b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c106b2",
  null
  
)

export default component.exports